<template>
    <div>
        <div class="md-layout">
            <div class="md-layout-item md-size-95 mx-auto">
                <v-app>
                    <v-form lazy-validation ref="form" @submit.prevent="confirm">
                        <v-card class="window-card">
                            <v-card-title>
                                <span class="md-title" style``="color: #67ad5b">新增场景元件动作</span>
                            </v-card-title>
                            <v-card-text>
                                <v-text-field v-model="form.name" label="动作名称 *" :rules="[v => !!v || '动作名称不能为空']"></v-text-field>
                                <v-select v-model="form.template" :items="scene_obj_list" item-text="name" item-value="value" label="动作模板"></v-select>
                                <v-text-field v-model="form.animResource" label="动画资源 *" :rules="[v => !!v || '动画资源不能为空']" v-show="form.template === 'bfdh'"></v-text-field>
                                <v-text-field v-model="form.playSpeed" label="播放速率 *" :rules="[v => !!v || '播放速率不能为空']" v-show="form.template === 'bfdh'"></v-text-field>
                                <md-field v-show="form.template === 'bfdh'">
                                    <div class="md-layout">
                                        <div class="md-layout-item md-size-20">
                                            <label style="padding-top: 5px">是否倒播</label>
                                        </div>
                                        <div class="md-layout-item md-size-75">
                                            <v-switch v-model="form.replay"></v-switch>
                                        </div>
                                    </div>
                                </md-field>
                                <v-radio-group v-model="form.type">
                                    <v-radio label="动态参数：允许在任务中进行动态设置" value="dynamic"></v-radio>
                                    <v-radio label="静态参数：固定在当前定义的动作内部" value="static"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="success" type="submit">确定</v-btn>
                                <v-btn color="success" @click="cancel">关闭</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-app>
            </div>
        </div>
    </div>
</template>
<script>
import { SlideYDownTransition } from 'vue2-transitions'
import { extend } from 'vee-validate'
import { required, required_if } from 'vee-validate/dist/rules'

extend('required', required)
extend('required_if', required_if)
export default {
    props: {
        components: {
            SlideYDownTransition
        },
        index: {
            type: Number,
            default: -1
        },
        formData: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        formData: {
            deep: true,
            immediate: true,
            handler: function(val) {
                this.form = val
            }
        }
    },
    data() {
        return {
            lockview: '',
            scene_obj_list: [
                { value: 'bfdh', name: '播放动画' }
            ],
            form: {}
        }
    },
    methods: {
        confirm() {
            const time = new Date().getTime()
            if (this.index === -1 || !this.form.id) {
                this.form.id = `scene_${time}`
                this.form.create_time = time
            } else {
                this.form.update_time = time
            }
            this.$emit('handleConfirm', {
                form: this.form,
                index: this.index
            })
        },
        cancel() {
            this.$emit('handleCancel', {})
        }
    }
}
</script>
<style>
.window-card {
    box-shadow: 0 0px 0px 0 rgb(0 0 0 / 14%) !important;
}
</style>